var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicroscopeIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1236_3774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.24241 3.89573L13.7626 1.17968L13.3099 0.426281C13.0601 0.0104994 12.5199 -0.124442 12.1039 0.125577L9.09036 1.93624C8.67452 2.18609 8.5397 2.72626 8.78966 3.14228L9.24241 3.89573Z",
    fill: "url(#paint0_linear_1236_3774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4265 20.512C27.1745 20.0971 26.6337 19.9647 26.2188 20.2166L21.314 23.1961C21.5472 23.7557 21.6989 24.3563 21.7558 24.9844L27.1312 21.719C27.5465 21.467 27.6784 20.9268 27.4265 20.512Z",
    fill: "url(#paint1_linear_1236_3774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6606 28.2422H20.0239V25.5469C20.0239 23.1238 18.0525 21.1524 15.6294 21.1524C13.2063 21.1524 11.2349 23.1238 11.2349 25.5469V28.2422H8.59814C8.11275 28.2422 7.71924 28.6357 7.71924 29.1211C7.71924 29.6065 8.11275 30 8.59814 30H22.6606C23.146 30 23.5396 29.6065 23.5396 29.1211C23.5396 28.6357 23.146 28.2422 22.6606 28.2422ZM15.6294 26.4258C15.144 26.4258 14.7505 26.0323 14.7505 25.5469C14.7505 25.0615 15.144 24.668 15.6294 24.668C16.1148 24.668 16.5083 25.0615 16.5083 25.5469C16.5083 26.0323 16.1148 26.4258 15.6294 26.4258Z",
    fill: "url(#paint2_linear_1236_3774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.09345 7.06115L10.0206 8.60422L11.8953 7.47066C14.1175 6.12705 16.9823 6.87582 18.3009 9.03113C19.658 11.2497 18.9467 14.1438 16.7153 15.4801L14.8304 16.609L15.4309 17.6084C15.6819 18.0261 16.2244 18.1589 16.6395 17.9075C16.6672 17.8909 16.9614 17.7141 17.4056 17.4471L18.754 19.6913C19.0044 20.108 19.5452 20.2413 19.9601 19.992L22.9735 18.1813C23.3896 17.9313 23.5242 17.3914 23.2743 16.9753L21.9258 14.7311C22.3757 14.4608 22.6639 14.2877 22.6639 14.2877C23.08 14.0377 23.2145 13.4977 22.9646 13.0817C22.9436 13.0467 16.6214 2.52307 16.5983 2.48949C16.3352 2.10652 15.8195 1.99449 15.4212 2.23385L9.39415 5.85512C8.97808 6.10514 8.84343 6.64508 9.09345 7.06115Z",
    fill: "url(#paint3_linear_1236_3774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.47705 25.5469C9.47705 23.827 10.1868 22.2699 11.3284 21.1524H10.356C8.90207 21.1524 7.71924 19.9696 7.71924 18.5157C7.71924 17.0618 8.90207 15.8789 10.3556 15.8789C10.356 15.8789 12.3839 15.8798 12.3838 15.8798C12.5429 15.8798 12.6989 15.8366 12.8354 15.7549L15.8123 13.972C17.2044 13.1383 17.6484 11.3326 16.8017 9.94844C15.9668 8.58373 14.1739 8.14715 12.8051 8.97478L10.1037 10.6083C5.85824 10.7416 2.4458 14.2375 2.4458 18.5157C2.4458 22.5803 5.52748 25.9381 9.47705 26.3767V25.5469Z",
    fill: "url(#paint4_linear_1236_3774)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1236_3774",
    x1: 8.73524,
    y1: 3.11658,
    x2: 13.7626,
    y2: 3.11658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2E854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1236_3774",
    x1: 21.4011,
    y1: 24.0053,
    x2: 27.5543,
    y2: 24.0053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2E854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1236_3774",
    x1: 7.94008,
    y1: 28.2305,
    x2: 23.5396,
    y2: 28.2305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2E854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1236_3774",
    x1: 9.16924,
    y1: 16.5157,
    x2: 23.3999,
    y2: 16.5157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2E854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1236_3774",
    x1: 2.6522,
    y1: 22.8125,
    x2: 17.2312,
    y2: 22.8125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2E854"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1236_3774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroscopeIc);
export default __webpack_public_path__ + "static/media/microscope_ic.54014c5d75d4e67b46409fe028e68da4.svg";
export { ForwardRef as ReactComponent };